import React from 'react';
import classnames from 'classnames';
import { checkString, checkArray } from '../helpers/global'

const Combi = props => {

  const {data} = props;
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  if (checkArray(data.image_data)){
    img_src = data.image_data.toString();
  }
  if (!img_src) {

    img_src = data.image_url;
  }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }

  return (
    <>
    { data.past_event && data.slot_view_name ?
      <div className={"grid-item event " + `${data.slot_view_name}`} >
        <a href={data.url}
          className={"slot event " + `${data.slot_view_name}`}>
         {checkString(img_src) &&

           <div className="slot-image">
             <div className="image-container">

             {checkString(data.event_quicklinks)  &&
               <div className="quicklinks">{data.event_quicklinks}</div>
             }
              <div className="tags">
              {checkString(data.event_type) &&
                <div className="tag">{data.event_type}</div>
              }
              <div class="event-tag past-event slot-tag font-tag-small font-uppercase ">Past event</div>

              {checkString(data.festival_tag)  &&
                <div className="event-tag external">{data.festival_tag}</div>
              }
              </div>

              <img loading="lazy" srcset={img_src}  alt={img_alt} style={combiStyle} />
             </div>
           </div>
         }
          <div className="slot-content">
            <div className="slot-title font-s font-title" dangerouslySetInnerHTML={{__html: data.title}}/>
            <div className="slot-bottom">
            <div class="slot-info">
            {checkString(data.subtitle) &&
              <div className="slot-artists">{data.subtitle}</div>
            }
            {checkString(data.date_formatted) &&
              <div className="slot-date">{data.date_formatted}</div>
            }
            {checkString(data.venue_name) &&
              <div className="slot-venue">{data.venue_name}</div>
            }
            {checkString(data.min_price)  &&
              <div className="slot-price"><b>{data.min_price}</b></div>
            }

            </div>

            <a className="button button-white-border " target={checkString(data.yc_foreign_id) ? '_blank' : '_self'} href={data.url} >{data.link_title}</a>
            </div>
          </div>
        </a>
      </div>
      :
      <div className={"grid-item combi " + `${data.slot_view_name}`} >
        <a href={data.url}
          className={"slot " + `${data.slot_view_name}`}>
         {checkString(img_src) &&

           <div className="slot-image">
             <div className="image-container">
             <div class="tags">
             {checkString(data.slot_tag) &&
               <div className="tag slot-tag">{data.slot_tag}</div>
             }

             </div>
              <img loading="lazy" srcset={img_src}  alt={img_alt} style={combiStyle} />
             </div>
           </div>
         }
          <div className="slot-content">


            <div className="slot-title font-s font-title" dangerouslySetInnerHTML={{__html: data.title}}/>
            {data.date_formatted && checkString(data.date_formatted) &&
              <div className="slot-date" dangerouslySetInnerHTML={{__html: data.date_formatted}} />
            }
            {checkString(data.text) &&
              <div className="slot-text" dangerouslySetInnerHTML={{__html: data.text}} />
            }

          </div>
        </a>
      </div>


    }

    </>
  )
}

export default Combi;
